import { useCallback, useState } from 'react'

import { type UploadProgress } from 'pages/reelCreate/types'

export function useReelUploadProgress() {
  const [uploadProgress, setUploadProgress] =
    useState<UploadProgress | null>(null)

  const handleSetProgressInfo = useCallback(
    (
      percentage: number | null,
      cancelCb?: () => void,
      error?: string
    ) => {
      if (percentage === null) {
        setUploadProgress(null)
      } else {
        setUploadProgress({
          percentage,
          cancelCb,
          error
        })
      }
    },
    []
  )

  return {
    handleSetProgressInfo,
    uploadProgress,
    setUploadProgress
  }
}